import { IHttpTokenInterceptor } from "./HttpTokenInterceptor";
import type { AxiosInstance } from "axios";
import { AxiosHeaders } from "axios";
import type { IStorage } from "@/core/plugins/storage/Storage";
import { DITypes, LocalStorageKeys } from "@/core/@types/types";
import { injectable, inject } from "inversify";
import { isAuthenticationRequest, isSessionLoginRedirecting, ensureSessionToken, SessionExpiredError, sessionRequestUrl } from "./SessionAuthentication";
import "reflect-metadata";

@injectable()
export default class AxiosHttpTokenInterceptor implements IHttpTokenInterceptor<AxiosInstance> {
  @inject(DITypes.STORAGE)
  private storage!: IStorage;

  intercept(axios: AxiosInstance, requiresBearer = true): void {
    axios.interceptors.request.use(async (config) => {
      const url = sessionRequestUrl(config.url, config.baseURL);
      if (isAuthenticationRequest(url)) return config;
      if (isSessionLoginRedirecting()) throw new SessionExpiredError();
      if (!requiresBearer) return config;
      const token = await ensureSessionToken(this.storage.get(LocalStorageKeys.TokenNewHorizons), config.method || "GET", url);
      this.storage.set(LocalStorageKeys.TokenNewHorizons, token);
      const headers = AxiosHeaders.from(config.headers);
      if (!headers.get("Content-Type") && !(config.data instanceof FormData)) headers.set("Content-Type", "application/json");
      headers.set("X-Requested-With", "XMLHttpRequest");
      headers.set("Authorization", `Bearer ${token}`);
      config.headers = headers;

      return config;
    });
  }
}
